import { ConnectionName } from '../types'

export const mapToUrl = (name: ConnectionName): string => {
  switch (name) {
    case 'googleAdwords':
    case 'googleAnalytics':
    case 'googleBigquery':
      return name.toLowerCase()
    default:
      return name
  }
}

export const mapToConnectionName = (name: string): ConnectionName => {
  switch (name) {
    case 'googleadwords':
      return 'googleAdwords'
    case 'googleanalytics':
      return 'googleAnalytics'
    case 'googlebigquery':
      return 'googleBigquery'
    default:
      return name as ConnectionName
  }
}
